<template>
  <Card>
    <h3>All Events</h3>
    <p>This table shows how many recommeded figures are associated with each event, validity of the end dates of an event its associated facts and tag validity.</p>
    <Alert type="error">
      <h4>Table Temporary Disabled</h4>
      <span slot="desc">This table has been temporary disabled while working on fixes on its query.</span>
    </Alert>
    <!-- <ag-grid-vue
      style="width: 100%; height: 420px;"
      class="ag-theme-material"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :rowData="tableData"
    ></ag-grid-vue>-->
  </Card>
</template>

<script>
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";

export default {
  components: { AgGridVue },
  data() {
    return {
      tableData: [],
      gridOptions: {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
        },
        sideBar: {
          toolPanels: ["columns", "filters"],
          defaultToolPanel: "",
        },
        enableRangeSelection: true,
        allowContextMenuWithControlKey: true,
        onFirstDataRendered: params => {
          params.api.sizeColumnsToFit();
        },
        getContextMenuItems: params => [
          {
            name: "Go to Event",
            action: () => {
              const id = params.node.data.event_id;
              this.$router.push(`/events/${id}`);
            },
          },
          {
            name: "Go to Fact",
            action: () => {
              const id = params.node.data.fact_id;
              this.$router.push(`/facts/${id}`);
            },
          },
          "separator",
          ...params.defaultItems,
        ],
      },
      columnDefs: Object.freeze([
        // {
        //   headerName: "ID",
        //   width: 40,
        //   field: "id",
        // },
        {
          headerName: "Name",
          field: "name",
        },
        {
          headerName: "# Facts",
          width: 40,
          field: "total_facts",
        },
        {
          headerName: "# RF",
          width: 40,
          field: "total_recommeded_figure",
        },
        {
          headerName: "️⚠️Event",
          width: 40,
          field: "is_wrong_events_dates_order",
          valueFormatter: ({ value }) => (value ? "⚠️" : ""),
          sortable: true,
        },
        {
          headerName: "Event SD",
          width: 40,
          field: "event_start_date",
          sortable: true,
        },
        {
          headerName: "Event ED",
          width: 40,
          field: "event_end_date",
          sortable: true,
        },
        {
          headerName: "️️⚠️Fact",
          width: 40,
          field: "is_wrong_facts_dates_order",
          valueFormatter: ({ value }) => (value ? "⚠️" : ""),
          sortable: true,
        },
        {
          headerName: "Fact SD",
          width: 40,
          field: "fact_start_date",
          sortable: true,
        },
        {
          headerName: "Fact ED",
          width: 40,
          field: "fact_end_date",
          sortable: true,
        },
      ]),
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      let response = await axios.get("/psql/qa_dashboard_all_events");
      console.log(response);
      this.tableData = response.data;
    },
  },
};
</script>
